<div class="aligner-center">
  <font-awesome [icon]="'fa-duotone fa-file-circle-question font-size-100 opacity-50'"></font-awesome>
  <div class="mt-4">Unable to load data</div>
</div>
